import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../lib/api';
import RecipeCard from '../components/RecipeCard';

export default function Favorites() {
  const { t } = useLang();
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    api.get('/favorites').then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, [user]);

  if (!user) {
    return (
      <div className="text-center py-20 space-y-4" data-testid="favorites-page">
        <Heart className="h-12 w-12 mx-auto text-[#C05A42]" />
        <p className="text-[#5C4D44]">{t('needLogin')}</p>
        <Link to="/login" className="inline-flex items-center rounded-full bg-[#C05A42] text-white px-6 py-3 text-sm font-medium hover:bg-[#A04832] transition" data-testid="login-link">{t('loginWithGoogle')}</Link>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="favorites-page">
      <h1 className="text-3xl sm:text-4xl font-display font-bold tracking-tight">{t('favorites')}</h1>
      {loading ? <div>...</div> : items.length === 0 ? (
        <p className="text-[#5C4D44] py-12 text-center">{t('favEmpty')}</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((r, i) => <RecipeCard key={r.recipe_id} recipe={r} index={i} />)}
        </div>
      )}
    </div>
  );
}
